export default "__VITE_ASSET__i0U$vHO6__"